
export interface seriesList {
    id: string;
    name: string;
}

export interface ProtectorDto {
    housingDiaIn: number;
    housingDiamm: number;
    hp: number;
    hsShaftHP: number;
    model: string;
    name: string;
    protectorID: string;
    series: string;
    stdShaftHP: number;
    tempetaureRating: number;
}

export interface ProtectorListProps {
    showError: string[];
    setShowError: any,
}

export const Protector400Series: string[] = ['400/400', '400/420', '400/456'];

export const Protector300Series: string[] = ['338/375'];

export const Protector500Series: string[] = ['513/540'];